import { isFromV2Session } from '@/utils/platformMigrationHelper';
import { resolveEmbedFlags } from '@/utils/embedChrome';

export default {
  data() {
    return {
      isIframe: false,
      isV2Embed: false,
    };
  },
  methods: {
    /**
     * Detects an embed from localStorage iframe-view.
     * closeCta marks any embed. source marks the V2 embed, and it stays
     * with iframe-view across a refresh and a new tab. A session that
     * arrived before source was stored still counts, and is written back.
     */
    detectIframe() {
      const raw = localStorage.getItem('iframe-view');
      const view = resolveEmbedFlags(raw, isFromV2Session());
      this.isIframe = view.isIframe;
      this.isV2Embed = view.isV2Embed;
      if (view.nextIframeView) localStorage.setItem('iframe-view', view.nextIframeView);

      // Close sidebar if in iframe
      if (this.isIframe) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
      }
    },
    /**
     * Shows the sidebar if not in iframe mode
     */
    showSidebar() {
      if (this.isIframe) return;
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
  },
};

